<div *hasScope="SCOPES.CANCELLATION_REASONS.UPDATE">

<form [formGroup]="cancellationReasonFormedit" (ngSubmit)="submitForm()" class="flex flex-col gap-6">
  <div class="rounded-2xl bg-white p-6 shadow-sm">
    <div class="grid grid-cols-2 gap-4">
      <div class="flex flex-col gap-2">
        <app-filter-input
          [label]="titleArLabel"
          [required]="true"
          [placeholder]="titleArPlaceholder"
          [value]="titleAr()"
          (valueChange)="onArabicChange($event)"
          [isInvalid]="titleArControl().invalid && titleArControl().touched" />

        @if (titleArControl().invalid && titleArControl().touched) {
          <span class="textError text-[12px]">
            @if (titleArControl().errors?.["arabicOnly"]) {
              <span i18n="@@cancellationReasonArabicOnly">Reason Title (Arabic) must contain Arabic letters only</span>

            } @else if (titleArControl().errors?.["spaces"]) {
              <span i18n="@@cancellationReasonArabicSpaces">Arabic Reason title cannot start or end with spaces</span>

            } @else if (titleArControl().errors?.["numbers"]) {
              <span i18n="@@cancellationReasonArabicNumbers">Reason Name cannot contain numbers</span>

            } @else if (titleArControl().errors?.["minlength"]) {
              <span i18n="@@cancellationReasonArabicMinLength">Reason Name must be at least 3 characters</span>

            } @else if (titleArControl().errors?.["maxlength"]) {
              <span i18n="@@cancellationReasonArabicMaxLength">Reason Name cannot exceed 255 characters</span>

            } @else if (titleArControl().errors?.["required"]) {
              <span i18n="@@cancellationReasonArabicRequired">Reason Name in Arabic is required</span>
            }
          </span>
        }
      </div>

      <!-- English -->

      <div class="flex flex-col gap-2">
        <app-filter-input
          [label]="titleEnLabel"
          [placeholder]="titleEnPlaceholder"
          [value]="titleEn()"
          (valueChange)="onEnglishChange($event)"
          [isInvalid]="titleEnControl().invalid && titleEnControl().touched" />
        @if (titleEnControl().invalid && titleEnControl().touched) {
          <span class="textError text-[12px]">
            @if (titleEnControl().errors?.["englishOnly"]) {
              <span i18n="@@cancellationReasonEnglishOnly">
                Reason Title (English) must contain English letters only
              </span>

            } @else if (titleEnControl().errors?.["spaces"]) {
              <span i18n="@@cancellationReasonEnglishSpaces">English Reason title cannot start or end with spaces</span>

            } @else if (titleEnControl().errors?.["numbers"]) {
              <span i18n="@@cancellationReasonEnglishNumbers">Reason Name cannot contain numbers</span>

            } @else if (titleEnControl().errors?.["minlength"]) {
              <span i18n="@@cancellationReasonEnglishMinLength">Reason Name must be at least 3 characters</span>

            } @else if (titleEnControl().errors?.["maxlength"]) {
              <span i18n="@@cancellationReasonEnglishMaxLength">Reason Name cannot exceed 255 characters</span>
            }
          </span>
        }
      </div>
    </div>

    @if (submitAttempted() && !isFormTouched()) {
      <app-error
        [apiError]="isArabic() ? 'من فضلك قم بتعديل أي حقل قبل الحفظ' : 'Please make any change before saving'"
        class="mt-4 block" />
    }

    <div class="mt-10 flex justify-end gap-3 ">
<app-submit-button class="hover:cursor-pointer"
  type="secondary"
  (click)="cancel()">
  {{ cancelButton }}
</app-submit-button>
<app-submit-button  class="hover:cursor-pointer"   type="primary">
    {{ submitButton }}
</app-submit-button>
    </div>
  </div>
</form>

@if (showConfirmation()) {
  <app-confirmation-dialog
    [layout]="'start'"
    [title]="confirmationTitle"
    [description]="confirmationDescription"
    [error]="errorMessage()"
    [cancelContent]="cancelButton"
    [confirmContent]="confirmButton()"
    (onCancel)="closeConfirmation()"
    (onSubmit)="confirmCreate()" />
}

@if (successMessage()) {
  <app-successful-notification type="success" [title]="successMessage()!" />
}
</div>
